import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";

export const ModalWarning = ({ children }: React.PropsWithChildren<{}>) => {
    return (
        <>
            <p style={{ fontSize: 100 + 'px' }} className="text-center text-warning">
                <FontAwesomeIcon icon={faCircleExclamation} id="FailureStatus" aria-hidden="true" />
            </p>
            <p className="text-center">
                {children}
            </p>
        </>
    );
}
